import {useParamInSessionStorage} from '@hooks/useParamInSessionStorage';

export const useIsLxpAdmin = (enabled: boolean = true) => {
  return useParamInSessionStorage(enabled, 'lxpAdmin');
};
